import { GfsAssessmentAdditionalInfoPage } from "@/services/backend/gfs/assessment/components/assessment-additional-info-page";

export default function GfsAssessmentAdditionalInfoRoute() {
  return <GfsAssessmentAdditionalInfoPage />;
}
